import { useState } from "react";
import Caseoption from "./Caseoption";
import Case from "./Case";
import casedata from "./casedata.json";
import industrylist from "./industrylist.json";

const industryList = industrylist;

const CaseList = () => {
  const [caseList, setCaseList] = useState(casedata);
  const [activeFilter, setActiveFilter] = useState("");

  const filteCaseList = (industryType: string) => {
    setActiveFilter(industryType);
    if (industryList.includes(industryType)) {
      setCaseList(casedata.filter((item) => item.industry === industryType));
    } else {
      setCaseList(casedata);
    }
  };

  return (
    <>
      <div className="caselist-header">
        <h1>Case Studies</h1>
        <p>Real problems. Real solutions. See how we've helped businesses grow.</p>
        <Caseoption arr={industryList} filterCaseList={filteCaseList} activeFilter={activeFilter} />
        <span className="caselist-count">{caseList.length} {caseList.length === 1 ? "project" : "projects"}</span>
      </div>
      <Case caseList={caseList} />
    </>
  );
};

export default CaseList;
